import { render, staticRenderFns } from "./selectAdminCommunity.vue?vue&type=template&id=d9f6bfa2&scoped=true"
import script from "./selectAdminCommunity.vue?vue&type=script&lang=js"
export * from "./selectAdminCommunity.vue?vue&type=script&lang=js"
import style0 from "./selectAdminCommunity.vue?vue&type=style&index=0&id=d9f6bfa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f6bfa2",
  null
  
)

export default component.exports